// DS: i5.2
import React from 'react';
import IconWrap from '../../IconWrap';
const Comment = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15 2a1 1 0 0 0-1-1H3.914a1 1 0 0 0-.707.293L1.293 3.207A1 1 0 0 0 1 3.914V11a1 1 0 0 0 1 1h3v2a1 1 0 0 0 1 1h.465a1 1 0 0 0 .832-.445L9 12h3.086a1 1 0 0 0 .707-.293l1.914-1.914A1 1 0 0 0 15 9.086V2Z"
    })));
};
Comment.displayName = 'Comment';
export default Comment;

//# sourceMappingURL=Comment.js.map